'use client'

import { useFormContext } from '@ariakit/react'
import { useContext } from 'react'

import { ProductCatalogVariant } from '../../../__generated__/graphql/catalog/graphql'

import { VariantSelectionFormContext, VariantSelectionFormState } from './VariantSelectionForm'

const actionableAvailabilities: Array<ProductCatalogVariant['availability']> = [
  'AVAILABLE',
  'WAIT_LISTING',
]

/**
 * Derived purchasing state:
 * - allVariantFieldsFilled: both size & fit are selected
 * - notFound: fields filled but no selected variant
 * - disabled: loading || notFound || unavailable
 */
export const useVariantSelectionPurchasingState = () => {
  const { selectedVariant, loading } = useContext(VariantSelectionFormContext)!
  const formContext = useFormContext()
  const fit = formContext!.useValue<VariantSelectionFormState['fit']>('fit') ?? ''
  const size = formContext!.useValue<VariantSelectionFormState['size']>('size') ?? ''

  const allVariantFieldsFilled = size.length > 0 && fit.length > 0
  const notFound = allVariantFieldsFilled && !selectedVariant
  const disabledAvailability =
    allVariantFieldsFilled &&
    selectedVariant?.availability &&
    !actionableAvailabilities.includes(selectedVariant.availability)
  const disabled = loading || notFound || disabledAvailability

  return { disabled, allVariantFieldsFilled, notFound }
}
